import { createAsyncThunk } from '@reduxjs/toolkit';

import { OverviewService } from 'api';

export const getInvestmentStatistic = createAsyncThunk(
	'overview/getInvestmentStatistic',
	async (type: any) => {
		return (await type) === 'investment_statuses'
			? OverviewService.getInvestmentStatuses(type)
			: OverviewService.getInvestmentStatistic(type);
	},
);
